import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import i18n from '@/i18n'

// 公共API的baseURL（用于前端公开接口）
export const PUBLIC_API_BASE = process.env.PUBLIC_API_BASE || 'https://skyautomax.com/api'

// 搜索API的baseURL（用于ES搜索接口）
export const SEARCH_API_BASE = process.env.SEARCH_API_BASE || 'https://skyautomax.com/search-api'

// 创建axios实例（用于管理后台接口）
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// 创建公开接口的axios实例（用于前端公开接口）
const publicService = axios.create({
  baseURL: PUBLIC_API_BASE, // 公开接口的base_url
  timeout: 15000 // 请求超时时间
})

// 创建搜索接口的axios实例（用于ES搜索接口）
const searchService = axios.create({
  baseURL: SEARCH_API_BASE,
  timeout: 15000
})

function getRequestLanguage() {
  const lang = store.getters.language || localStorage.getItem('mall-pc-web-language') || 'en-US'
  return lang === 'en-US' ? 'en-US' : 'zh-CN'
}

// request拦截器
service.interceptors.request.use(config => {
  config.headers['Accept-Language'] = getRequestLanguage()
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// 响应拦截器（通用）
const responseInterceptor = (response) => {
  // 如果是blob类型（文件下载），直接返回response
  if (response.config.responseType === 'blob' || response.data instanceof Blob) {
    return response.data
  }
  
  /**
   * code为200或0表示成功，其他值表示失败
   * 兼容不同的接口返回格式
   */
  const res = response.data
  // code 为 200 或 0 表示成功
  if (res.code !== 200 && res.code !== 0) {
    Message({
      message: res.message || i18n.t('tip.requestFailed'),
      type: 'error',
      duration: 3 * 1000
    })

    // 401:未登录;
    if (res.code === 401) {
      MessageBox.confirm(
        i18n.t('tip.sessionExpiredMessage'),
        i18n.t('tip.sessionExpiredTitle'),
        {
          confirmButtonText: i18n.t('tip.reLogin'),
          cancelButtonText: i18n.t('tip.cancel'),
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('FedLogOut').then(() => {
          location.reload()// 为了重新实例化vue-router对象 避免bug
        })
      })
    }
    return Promise.reject('error')
  } else {
    return response.data
  }
}

const errorInterceptor = (error) => {
  console.log('err' + error)// for debug
  Message({
    message: error.message,
    type: 'error',
    duration: 3 * 1000
  })
  return Promise.reject(error)
}

// 管理后台接口的响应拦截器
service.interceptors.response.use(responseInterceptor, errorInterceptor)

// 公开接口的请求拦截器（可选添加token）
publicService.interceptors.request.use(config => {
  config.headers['Accept-Language'] = getRequestLanguage()
  // 如果已登录，也可以携带token（某些公开接口可能需要）
  if (store.getters.token) {
    config.headers['Authorization'] = getToken()
  }
  return config
}, error => {
  console.log(error) // for debug
  Promise.reject(error)
})

// 公开接口的响应拦截器
publicService.interceptors.response.use(responseInterceptor, errorInterceptor)

searchService.interceptors.request.use(config => {
  config.headers['Accept-Language'] = getRequestLanguage()
  if (store.getters.token) {
    config.headers['Authorization'] = getToken()
  }
  return config
}, error => Promise.reject(error))

// 搜索接口的响应拦截器（兼容无code返回）
searchService.interceptors.response.use((response) => {
  if (response.config.responseType === 'blob' || response.data instanceof Blob) {
    return response.data
  }
  const res = response.data
  if (res && typeof res === 'object' && Object.prototype.hasOwnProperty.call(res, 'code')) {
    if (res.code !== 200 && res.code !== 0) {
      Message({
        message: res.message || i18n.t('tip.requestFailed'),
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject('error')
    }
    return res
  }
  return res
}, errorInterceptor)

// 导出公开接口的请求实例
export const publicRequest = publicService

// 导出搜索接口的请求实例
export const searchRequest = searchService

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js